export default {
  ORGANIZATION: 'organization',
  JOB_TITLE: 'job_title',
  DEPARTMENT: 'department',
  LIST: 'list',
};
